<div class="tabspl">
    <div class="tabrow">
        <div class="clearfix"></div>
        <div class="col-12 f-search-wrap mobile_nopad">
            <form [formGroup]="regConfig">
                <div class="row mobile_row">
                    <div class="col-md-8 col-12 nopad">
                        <div class="valign-wrapper field-outer ai-fs nav">
                            <div class="col-md-6 col-12 padrt10">
                                <label class="bold fs-18">
                                    Location / City
                                </label>
                                <input placeholder="Location / City" type="text" class="validate searchinput"
                                    (keyup)="getAutoCompleteLocations($event)" for="dynmicLocations"
                                    formControlName="cityName"
                                    [ngStyle]="{'background': isLoading ? 'url(./assets/images/loader-inp.gif) no-repeat scroll 98% center #092C3B' : '' }"
                                    #destination_name>
                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('cityName', 'required');">
                                    Please Enter Location/City* </small>
                                <ul class="droplocations" id="dynmicLocations">
                                    <li *ngFor="let location of locations" (click)="selectedLocation(location)"><i
                                            class="fal fa-map-marker-alt"></i> {{location.cityName +' ('+
                                        location.countryCode +')'}}</li>
                                </ul>
                            </div>
                            <div class="col-md-3 col-12 padrt10" id="">
                                <label class="bold fs-18">Check In</label>
                                <span class="micon"><i class="fal fa-calendar-alt"></i></span>
                                <input type="text" id="checkin" formControlName="checkin"
                                    class="validate datepick searchinput" placement="bottom left"
                                    placeholder="Select Date" bsDatepicker [bsConfig]="bsDateConf" [readonly]="true"
                                    (ngModelChange)="onCheckIn($event)" [minDate]="minDate" [isOpen]="isOpen"
                                    #checkinDate>
                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('checkin', 'required');"> Please
                                    Enter Check In Date* </small>
                            </div>
                            <div class="col-md-3 col-12 padrt10" id="">
                                <label class="bold fs-18">Check Out</label>
                                <span class="micon"><i class="fal fa-calendar-alt"></i></span>
                                <input type="text" id="return" formControlName="checkout"
                                    class="validate datepick round-trip searchinput" placement="bottom left"
                                    placeholder="Select Date" bsDatepicker [bsConfig]="bsDateConf"
                                    (ngModelChange)="onCheckOut($event)" [isOpen]="isOpen"
                                    [minDate]="regConfig.controls.checkin.value || setMinDate" [readonly]="true"
                                    [isDisabled]="regConfig.controls.checkin.value ? false : true" #checkoutDate>

                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('checkout', 'required');">
                                    Please Enter Check Out Date* </small>
                            </div>
                        </div>
                    </div>
                    <!-- start traveller -->
                    <div class="col-md-4 col-12 nopad">
                        <div class="valign-wrapper field-outer ai-fs">
                            <div class="col-md-7 padrt10">
                                <label class="bold fs-18">Travelers</label>
                                <div class="dropdown" novalidate (validSubmit)="onSubmitTraveller()">
                                    <div class="traveller-input tp2 valign-wrapper fs-18">
                                        <span class="remngwd" (click)="travellersFadeinn=!travellersFadeinn">
                                            <span class="total_pax_count">
                                                <span id="travel_text"> {{noOfRooms}} Room,</span>
                                                <span id="travel_text"> {{noOfAdults}} Adult</span>
                                                <span id="travel_text" *ngIf="noOfChild > 0">, {{noOfChild}}
                                                    Child</span>
                                                &nbsp;
                                            </span>
                                        </span>
                                        <div class="roomcount pax_count_div {{travellersFadeinn ? 'fadeinn' : ''}}"
                                            *ngIf="travellersFadeinn">
                                            <div class="inallsn">
                                                <ng-container formArrayName="traveller">
                                                    <ng-container
                                                        *ngFor="let item of regConfig.get('traveller')['controls']; index as i"
                                                        [formGroupName]="i">
                                                        <div class="oneroom fltravlr pb-0">
                                                            <div #myDetails class="lablform2">
                                                                Room {{i+1}}
                                                            </div>
                                                            <div class="clearfix"></div>
                                                            <div class="roomrow">
                                                                <div class="celroe col-md-7">
                                                                    <i class="fa fa-male"></i> Adults
                                                                    <span class="agemns">(12+ yrs)</span>
                                                                </div>
                                                                <div class="celroe col-md-5">
                                                                    <div
                                                                        class="input-group countmore pax-count-wrapper adult_count_div">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'adults', 'minus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="minus" data-field="adult">
                                                                                <span class="fa fa-minus"></span>
                                                                            </button>
                                                                        </span>
                                                                        <input formControlName="adults" type="text"
                                                                            id="OWT_adult" name="adult"
                                                                            class="form-control input-number centertext valid_class pax_count_value"
                                                                            value="1" min="1" max="9" readonly="">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'adults', 'plus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="plus" data-field="adult">
                                                                                <span class="fa fa-plus"></span>
                                                                            </button>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="roomrow last">
                                                                <div class="celroe col-md-7">
                                                                    <i class="fa fa-child"></i> Children
                                                                    <span class="agemns">(2-11 yrs)</span>
                                                                </div>
                                                                <div class="celroe col-md-5">
                                                                    <div
                                                                        class="input-group countmore pax-count-wrapper child_count_div">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'childrens', 'minus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="minus" data-field="child">
                                                                                <span class="fa fa-minus"></span>
                                                                            </button>
                                                                        </span>
                                                                        <input formControlName="childrens" type="text"
                                                                            id="OWT_child" name="child"
                                                                            class="form-control input-number centertext pax_count_value"
                                                                            value="0" min="0" max="9" readonly="">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'childrens', 'plus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="plus" data-field="child">
                                                                                <span class="fa fa-plus"></span>
                                                                            </button>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button *ngIf="noOfRooms == i"
                                                                class="add_rooms comnbtn_room" style="display: block;"
                                                                (click)="addRoom()">
                                                                <i class="fa fa-plus-circle"></i>&nbsp;Add room
                                                            </button>
                                                            <button *ngIf="noOfRooms == i+1"
                                                                class="add_rooms comnbtn_room" style="display: block;"
                                                                (click)="removeRoom(i)">
                                                                <i class="fa fa-plus-circle"></i>&nbsp;Remove room
                                                            </button>

                                                            <div class="clearfix"></div>

                                                            <button style="float:right; margin-bottom:10px;"
                                                                *ngIf="noOfRooms == i" (click)="closeTravellers()"
                                                                class="btn btn-success">OK</button>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5 nopad">
                                <label class="bold fs-18">
                                    &nbsp;
                                </label>
                                <div class="all-btn shwroombtn">
                                    <button class="waves-effect" type="submit" (click)="onSubmit()">

                                        Search Hotels

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end traveller -->
                </div>
            </form>
        </div>
    </div>
</div>